/**
 * Created by quikr on 8/1/16.
 */
import * as actions from "../actionTypes";

export function displayError(error) {
  return {type: actions.DISPLAY_ERROR, error};
}
export function noError() {
  return {type: actions.NO_ERROR};
}



/** WEBPACK FOOTER **
 ** ./src/redux/actions/Errors/errorActions.js
 **/